import { __decorate } from "tslib";
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { EPassCodeStatus, EPortraitStatus } from '@blade-sxp/portrait-management/interfaces/portrait';
import InputSearch from '@blade-sxp/portrait-management/components/input-search.vue';
import lang from '@blade-sxp/portrait-management/lang/index';
let PortraitSearch = class PortraitSearch extends Vue {
    value;
    refresh;
    portraitStatusOptions = [
        {
            label: this.$t('all'),
            value: 'all',
        },
        {
            label: this.$t('valid'),
            value: EPortraitStatus.NORMAL,
        },
        {
            label: this.$t('notExpired'),
            value: EPortraitStatus.UNEFFECTIVE,
        },
        {
            label: this.$t('expired'),
            value: EPortraitStatus.INVALIDATING,
        },
    ];
    passCodeStatusOptions = [
        {
            label: this.$t('all'),
            value: 'all',
        },
        {
            label: this.$t('generated'),
            value: EPassCodeStatus.GENERATED,
        },
        {
            label: this.$t('notGenerated'),
            value: EPassCodeStatus.UNGENERATE,
        },
    ];
    onFormChange(nv) {
        this.$emit('update:value', nv);
    }
    refreshList() {
        this.refresh && this.refresh();
    }
};
__decorate([
    Prop({ default: () => ({}) })
], PortraitSearch.prototype, "value", void 0);
__decorate([
    Prop()
], PortraitSearch.prototype, "refresh", void 0);
__decorate([
    Watch('value', { deep: true })
], PortraitSearch.prototype, "onFormChange", null);
PortraitSearch = __decorate([
    Component({
        name: 'portraitSearch',
        components: { InputSearch },
        i18n: {
            messages: lang,
        },
    })
], PortraitSearch);
export default PortraitSearch;
